export const portfolioLogos = () => {
    const portfolioLogos = document.querySelector<HTMLElement>('.portfolio-logos')
    const controls = document.querySelector<HTMLButtonElement>('.portfolio-logos__controls');

    const setControlsLabel = () => {
        const paused = !!portfolioLogos?.classList.contains('pause');
        controls?.setAttribute('aria-label', paused ? 'Play logo marquee' : 'Pause logo marquee');
    };
    setControlsLabel();

    controls?.addEventListener('click', () => {
        portfolioLogos?.classList.toggle('pause')
        controls.classList.toggle('active')
        setControlsLabel();
    })

    const marquee = document.querySelector<HTMLElement>('.portfolio-logos__marquee')
    if (marquee) {
        const itemsCount = marquee.children.length;
        portfolioLogos?.style.setProperty('--items', itemsCount.toString());
    }
}